'use client';

import React, { createContext, useContext, useMemo, useState } from 'react';

export type ChatOnlyState = boolean;

interface ChatOnlyContextType {
  isChatOnly: ChatOnlyState;
  enableChatOnly: () => void;
  disableChatOnly: () => void;
  toggleChatOnly: () => void;
}

const ChatOnlyContext = createContext<ChatOnlyContextType | undefined>(undefined);

export const ChatOnlyProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isChatOnly, setIsChatOnly] = useState<ChatOnlyState>(false);

  const value = useMemo(
    () => ({
      isChatOnly,
      enableChatOnly: () => setIsChatOnly(true),
      disableChatOnly: () => setIsChatOnly(false),
      toggleChatOnly: () => setIsChatOnly((prev) => !prev),
    }),
    [isChatOnly]
  );

  return <ChatOnlyContext.Provider value={value}>{children}</ChatOnlyContext.Provider>;
};

// Custom hook
export const useChatOnly = (): ChatOnlyContextType => {
  const context = useContext(ChatOnlyContext);

  if (!context) {
    throw new Error('useChatOnly must be used inside ChatOnlyProvider');
  }

  return context;
};
